import {SCRIPT_TAG_START, SCRIPT_TAG_END} from "../../config/constants"
import getStringBetween from "../getStringBetween"

export const wrapWithScriptTags = (stringToBeWrapped: string) => {
    return `${SCRIPT_TAG_START}${stringToBeWrapped}${SCRIPT_TAG_END}`
}

export const removeScriptTags = (stringToBeSanitized: string) => {
    return getStringBetween(stringToBeSanitized, SCRIPT_TAG_START, SCRIPT_TAG_END)
}
